import { Box, Stack, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import type { ReactNode } from 'react';
import { Logo } from 'ui-component';

interface LogoBarProps {
    open: boolean;
    projectLogo: string;
    projectTitle: string;
    address?: string;
    children?: ReactNode;
}

const LogoBar = (props: LogoBarProps) => {
    const { open, projectLogo, projectTitle, address, children } = props;
    const theme = useTheme();
    const lgUp = useMediaQuery(theme.breakpoints.up('lg'));

    return (
        <Box
            sx={{
                height: open ? { xs: 64, sm: 68 } : 0,
                opacity: open ? 1 : 0,
                alignItems: 'center',
                display: 'flex',
                background: '#7eaaca',
                transition: 'height 0.4s ease, opacity 0.4s ease',
                overflow: 'hidden'
            }}
        >
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                spacing={0}
                sx={{ width: '100%', px: { xs: 1.5, sm: 3, lg: 4 }, minWidth: 0 }}
            >
                <Box sx={{ flexShrink: 0, mr: { xs: 2, sm: 3 } }}>
                    <Logo
                        logo={projectLogo}
                        dimensions={{ width: lgUp ? 50 : 42, height: lgUp ? 50 : 42 }}
                        styles={{ backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}
                    />
                </Box>
                <Box sx={{ minWidth: 0, flexGrow: 1 }}>
                    <Typography
                        component="div"
                        fontFamily="Inter"
                        fontSize={{ xs: '0.82rem', sm: '0.94rem', md: '1rem' }}
                        lineHeight={1.2}
                        fontWeight={400}
                        sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                    >
                        {projectTitle}
                    </Typography>
                    <Typography
                        component="div"
                        fontFamily="Inter"
                        fontSize={{ xs: '0.67rem', sm: '0.75rem', md: '0.8rem' }}
                        lineHeight={1.3}
                        fontWeight={400}
                        sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                    >
                        {address}
                    </Typography>
                </Box>
                <Box sx={{ flexShrink: 0, display: { xs: 'none', md: 'flex' } }}>{children}</Box>
            </Stack>
        </Box>
    );
};

export default LogoBar;
